/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  PostUsersIdRestoreMutationResponse,
  PostUsersIdRestorePathParams,
  PostUsersIdRestore400,
  PostUsersIdRestore403,
} from '../entities/PostUsersIdRestore'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { postUsersIdRestore } from '../api/postUsersIdRestore'
import { useMutation } from '@tanstack/react-query'

export const postUsersIdRestoreMutationKey = () => [{ url: '/users/{id}/restore' }] as const

export type PostUsersIdRestoreMutationKey = ReturnType<typeof postUsersIdRestoreMutationKey>

/**
 * @description Восстановление пользователя админом компании
 * @summary Восстановление пользователя
 * {@link /users/:id/restore}
 */
export function usePostUsersIdRestore<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostUsersIdRestoreMutationResponse,
      ResponseErrorConfig<PostUsersIdRestore400 | PostUsersIdRestore403>,
      { id: PostUsersIdRestorePathParams['id'] },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { mutation: { client: queryClient, ...mutationOptions } = {}, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? postUsersIdRestoreMutationKey()

  return useMutation<
    PostUsersIdRestoreMutationResponse,
    ResponseErrorConfig<PostUsersIdRestore400 | PostUsersIdRestore403>,
    { id: PostUsersIdRestorePathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return postUsersIdRestore(id, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}